import { render, staticRenderFns } from "./AddDispatchCar.vue?vue&type=template&id=51efc879&"
import script from "./AddDispatchCar.vue?vue&type=script&lang=js&"
export * from "./AddDispatchCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports